import React, {FunctionComponent, useEffect, useContext, useMemo} from 'react';
import { observer } from "mobx-react";
import {useLocation} from "react-router-dom";
import {Context} from '../../store/context';
import BuildingLogo from '../BuildingLogo/BuildingLogo';
import PathFinder from '../PathFinder/PathFinder';
import BuildingFooter from "../BuildingFooter/BuildingFooter";
import PathRating from "../PathRating/PathRating";
import NotFound from "../ui/NotFound/NotFound";
import {isFalse} from "../../utils/misc";
import WelcomeBanner from "../WelcomeBanner/WelcomeBanner";
import Splash from "../ui/Splash";

const SinglePathFinder = observer(() => {
    const query = useLocation().search;

    const {buildingsStore, queryParamsStore, nodesStore, pathFinderStore, languagesStore} = useContext(Context);
    const {queryParams, parseAndSetQuery, validateQueryParams} = queryParamsStore;
    const {building, getBuildingById, getMultiBuildings} = buildingsStore;
    const {getNodesByBuildingId} = nodesStore;
    const {pathFinder} = pathFinderStore;


    const buildingId: string | undefined= useMemo(() => {
        if(queryParams) return queryParams.buildingId;
        return undefined;
    }, [queryParams]);

    const multiBuildingsIds: string | null = useMemo(() => {
        if(queryParams && queryParams.MultiBuilding) return queryParams.MultiBuilding;
        return null;
    }, [queryParams])

    const isEmbeded: boolean = useMemo(() => {
        return window.self !== window.top
    }, [])

    useEffect(() => {
        parseAndSetQuery(query);
    }, [query]);

    useEffect(() => {
        if(!buildingId) return;
        getBuildingById(buildingId);
        getNodesByBuildingId(buildingId);
    }, [buildingId]);

    useEffect(() => {
        if(!multiBuildingsIds) return;
        const idxArray = queryParamsStore.multiBuildingArray;
        if(!idxArray) return;
        getMultiBuildings(idxArray);
    }, [multiBuildingsIds]);

    useEffect(() => {
        if(!building) return;
        const blangs = buildingsStore.buildingAvailableLanguages;
        validateQueryParams(building.lang, blangs);
    }, [building]);

    if(!languagesStore.currentIETF)
        return <Splash/>

    const incorrectUrl:boolean = !!building && !building.webApp;
    const showRating = !incorrectUrl && building?.showUserRatings &&
                        queryParams?.nodeFrom != queryParams?.nodeTo &&
                        isFalse(queryParams?.homepage) &&
                        pathFinder;
    const showFooter = !incorrectUrl &&
                        building?.storeLogo &&
                        pathFinder;

    return (
        incorrectUrl ?
            <NotFound/> :
            <div className="SinglePathFinder">
                <div className="visible-xs">
                    <WelcomeBanner building={building}/>
                </div>

                {!isEmbeded && building && <BuildingLogo src={buildingsStore.buildingLogo} alt="Building logo"/>}
                <div className="row">
                    <div className="col-xs-12">
                        <PathFinder/>
                    </div>
                </div>
                <div className="visible-xs">
                    {showRating && <PathRating />}
                    {showFooter && <BuildingFooter building={building} lang={queryParams?.routeLang}/>}
                </div>
            </div>
    )
});

export default SinglePathFinder
